import { Injectable } from '@angular/core';
import { PreInitSettingsService } from './settings/pre-init-setting.service';
import { SitefinityContentService } from './settings/sitefinity-content.service';
import { ISitefinityConfiguration } from 'src/app/model/sitefinity/sitefinitySettings';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PreInitSitefinityContentService {
  constructor(
    private httpClient: HttpClient,
    private preInitSettingsService: PreInitSettingsService,
    private sitefinityContentService: SitefinityContentService
  ) { }

  loadConfig(): Observable<any> {
    const settings = this.preInitSettingsService.getSettings();
    const middleWareUrl = settings.middleWare.middlewareUrl;
    const sitefinityMiddleware = settings.sitefinityCms.sitefinityMiddleWare;
    const selectedSiteSetting = this.preInitSettingsService.getSiteSettings();

    console.log(`site host name: ${window.location.hostname} : settingContentId : ${selectedSiteSetting.id}`);
    return this.getSitefinityConfig<ISitefinityConfiguration>(
      middleWareUrl + sitefinityMiddleware,
      selectedSiteSetting.id,
      selectedSiteSetting.provider
    )
      .pipe(
        tap(sitefinityConfig => {
          this.sitefinityContentService.setSettings({ sitefinityConfiguration: sitefinityConfig });
        })
      );
  }

  getSitefinityConfig<T>(cmsUrl: string, configurationId: string, sfProvider: string) {
    return this.httpClient.get<T>(`${cmsUrl}/clienttenantconfigurations?sf_site=${configurationId}&sf_provider=${sfProvider}`)
      .pipe(
        catchError((err) => {
          throw new Error('Error while fetching clienttenantconfigurations ' + err);
        })
      );
  }
}
